import React from "react";
import styled from "styled-components";
import { Button } from "../Button";
import { Icon } from "../Icon";
const StyledButton = styled(Button)(({ theme: { colors: { searchBoxColors }, shadows: { searchBox: { simpleShadow }, }, sizes, }, }) => ({
    "&.active": {
        background: searchBoxColors.buttonActiveBackground,
        borderColor: searchBoxColors.buttonActiveBackground,
    },
    "&:focus": {
        background: searchBoxColors.buttonFocusBackground,
        borderColor: searchBoxColors.buttonFocusBackground,
    },
    "&:hover": {
        background: searchBoxColors.buttonHoverBackground,
        borderColor: searchBoxColors.buttonHoverBackground,
    },
    background: searchBoxColors.buttonBackground,
    borderColor: searchBoxColors.buttonBackground,
    borderRadius: 0,
    boxShadow: simpleShadow,
    color: searchBoxColors.buttonText,
    height: "36px",
    minWidth: "unset",
    padding: sizes[2],
    textAlign: "center",
    top: 0,
    width: "50px",
}));
export const SearchBoxButton = ({ className }) => (React.createElement(StyledButton, { className: className, "data-testid": "searchButton" },
    React.createElement(Icon, { src: "Search", size: "16" })));
